export default __webpack_public_path__ + "static/media/Desktop.a1dac57e.png";